import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from "vue";

import OptimizeSignalAudioAndImpedancePanelAudioPanel from "@/components/audioAndImpedancePanel/components/OptimizeSignalAudioAndImpedancePanelAudioPanel.vue";
import OptimizeSignalAudioAndImpedancePanelImpedancePanel from "@/components/audioAndImpedancePanel/components/OptimizeSignalAudioAndImpedancePanelImpedancePanel.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'OptimizeSignalAudioAndImpedancePanel',
  props: {
    isSetup: { type: Boolean },
    nextRoute: {},
    impedancePanelDescription: {},
    stopRecording: { type: Function },
    runImpedanceCheck: { type: Function },
    isImpedanceCheckRunning: { type: Boolean },
    impedanceCheckChannel: {}
  },
  setup(__props: any) {



// ---- STATE ----

const carouselModel = ref(0);

// ---- CALLBACKS ----

const handleNextStep = () => (carouselModel.value += 1);

return (_ctx: any,_cache: any) => {
  const _component_VCarouselItem = _resolveComponent("VCarouselItem")!
  const _component_VCarousel = _resolveComponent("VCarousel")!
  const _component_VCard = _resolveComponent("VCard")!
  const _component_VCol = _resolveComponent("VCol")!

  return (_openBlock(), _createBlock(_component_VCol, { style: {"display":"flex","position":"absolute","top":"0","left":"0","width":"100vw","height":"100vh","background":"rgba(32, 32, 32, 0.73)","box-shadow":"0 8px 32px 0 rgba(31, 38, 135, 0.37)","backdrop-filter":"blur(3.5px)","-webkit-backdrop-filter":"blur(3.5px)","z-index":"2000","justify-content":"center","align-items":"center"} }, {
    default: _withCtx(() => [
      _createVNode(_component_VCard, {
        width: "85vh",
        style: {"top":"50px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_VCarousel, {
            "hide-delimiters": "",
            "show-arrows": false,
            modelValue: carouselModel.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((carouselModel).value = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_VCarouselItem, {
                class: "h-100",
                style: {"height":"100%"},
                value: "0"
              }, {
                default: _withCtx(() => [
                  _createVNode(OptimizeSignalAudioAndImpedancePanelAudioPanel, { onClose: handleNextStep })
                ]),
                _: 1
              }),
              _createVNode(_component_VCarouselItem, {
                class: "h-100",
                style: {"height":"100%"},
                value: "1"
              }, {
                default: _withCtx(() => [
                  _createVNode(OptimizeSignalAudioAndImpedancePanelImpedancePanel, {
                    isImpedanceCheckRunning: _ctx.isImpedanceCheckRunning,
                    impedanceCheckChannel: _ctx.impedanceCheckChannel,
                    runImpedanceCheck: _ctx.runImpedanceCheck,
                    nextRoute: _ctx.nextRoute,
                    description: _ctx.impedancePanelDescription,
                    "stop-recording": _ctx.stopRecording
                  }, null, 8, ["isImpedanceCheckRunning", "impedanceCheckChannel", "runImpedanceCheck", "nextRoute", "description", "stop-recording"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})